import type { IBlock } from "@Front/Components/DesignSystem/SearchBlockList/BlockList/Block";
import { ELegalOptions } from "./defaultLegalDashboardTypes";

function normalizeLegalUidQuery(legalUid: string | string[] | undefined): string | undefined {
	if (typeof legalUid === "string") {
		return legalUid;
	}
	if (Array.isArray(legalUid) && legalUid.length > 0) {
		return legalUid[0];
	}
	return undefined;
}

export function buildLegalDashboardBlocks(legalUid: string | string[] | undefined): IBlock[] {
	const active = normalizeLegalUidQuery(legalUid);
	const is = (id: ELegalOptions): boolean => active === id;
	return [
		{ id: ELegalOptions.LEGAL_MENTIONS, primaryText: "Mentions légales", isActive: is(ELegalOptions.LEGAL_MENTIONS) },
		{ id: ELegalOptions.CGU, primaryText: "CGU", isActive: is(ELegalOptions.CGU) },
		{ id: ELegalOptions.CGS, primaryText: "CGS", isActive: is(ELegalOptions.CGS) },
		{
			id: ELegalOptions.POLITIQUE_DE_CONFIDENTIALITE,
			primaryText: "Politique de confidentialité",
			isActive: is(ELegalOptions.POLITIQUE_DE_CONFIDENTIALITE),
		},
		{
			id: ELegalOptions.POLITIQUE_DE_GESTION_DES_COOKIES,
			primaryText: "Politique de gestion des cookies",
			isActive: is(ELegalOptions.POLITIQUE_DE_GESTION_DES_COOKIES),
		},
	];
}
